import * as React from 'react';
import * as Promise from 'bluebird';
import { Component } from 'react';
import {
  ColumnDefinition,
  convertToFilterWithPlus,
  getFilters,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter,
  isFilterExist,
  isSortExist,
  TABLE_SORT_DIRECTION,
} from 'Src/helpers/table';
import { CHECKBOX_FIELDS, DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE } from 'Src/consts/table';
import { parse } from 'query-string';
import { Loader } from 'Src/components/Loader/Loader';
import { Grid } from 'Src/components/Grid/Grid';
import { History, Location } from 'history';
import { imageCell } from '../../../../helpers/cell';
import { SchoolImageWithTicket } from '../../../../models/schoolImages';
import { SchoolJob } from '../../../../models/schoolJob';
import { SchoolJobImage } from '../../../../models/schoolImages';
import { getSchoolUserSchoolJob, approveSchoolJob } from '../../../../services/schoolUser/schoolJobs';
import { AppSchoolsUser2 } from '../../AppSchools2';
import {
  createSchoolUserSchoolJobImageTicket,
  getSchoolUserAllSchoolJobImages,
  getSchoolUserSchoolJobImages,
  getSchoolUserSchoolJobImagesCount,
  updateSchoolUserSchoolJobImage,
  createSchoolUserImagePreview,
} from '../../../../services/schoolUser/schoolJobImages';
import { SimpleModal } from '../../../../components/SimpleModal/SimpleModal';
import { SchoolAppSchoolJobImageForm } from './SchoolAppSchoolJobImageForm/SchoolAppSchoolJobImageForm';
import { SCHOOL_JOB_IMAGES_TABS, SCHOOL_JOB_STATUS } from '../../../../consts/schoolJob';
import { TABS } from '../../../../consts/common';
import { SchoolAppSchoolJobImageSummary } from './SchoolAppSchoolJobImageSummary/SchoolAppSchoolJobImageSummary';
import { GenericSummary } from '../../../../components/GenericSummary/GenericSummary';
import { ResizablePanel } from '../../../../components/ResizablePanel/ResizablePanel';
import { getSelectOptionForSchoolImageStatus } from '../../../../helpers/select';
import { getIsApproved } from '../../../../helpers/accessor';
import { Button } from 'Src/components/Button/Button';

const BASE_COLUMNS: ColumnDefinition[] = [
  {
    text: 'Image',
    field: 'image',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: imageCell,
  },
  {
    text: 'Title',
    field: 'staffDataTitle',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'title'],
  },
  {
    text: 'Name',
    field: 'staffDataName',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'name'],
  },
  {
    text: 'Surname',
    field: 'staffDataSurname',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'surname'],
  },
  {
    text: 'Job title',
    field: 'staffDataJobTitle',
    isSort: false,
    type: FILTER_TYPE.TEXT,
    accessor: ['staffData', 'jobTitle'],
  },
  {
    text: 'Status',
    field: 'isApproved',
    isSort: false,
    type: FILTER_TYPE.SELECT,
    accessor: getIsApproved,
  },
];

interface State {
  items: SchoolImageWithTicket[];
  currentPage: number;
  //  selectedItems: SchoolImageWithTicket[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  //  isSelectAllChecked: boolean;
  total: number;
  basePath: string;
  job: SchoolJob;
  isJobImageFormModalOpen: boolean;
  //  currentTabIndex: number;
  isConfirmHideModalOpen: boolean;
  selectedImageToHide?: SchoolImageWithTicket;
  isConfirmPreferredModalOpen: boolean;
  selectedImageForPreferred?: SchoolImageWithTicket;
  existingPreferredImage?: SchoolImageWithTicket;
  isPreviewModalOpen: boolean;
  selectedImageForPreview?: SchoolImageWithTicket;
  previewId: string;
  editingImage?: SchoolImageWithTicket;
  isReadOnlyMode: boolean;

  isConfirmFinalApproveModalOpen: boolean;
  selectedImageToApprove?: SchoolImageWithTicket;
}

interface LocationState {
  jobId?: string;
  search?: string;
}

interface Props {
  user: AppSchoolsUser2;
  history: History;
  location: Location & { state: LocationState };
}

export class SchoolAppSchoolJobImages2 extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      //      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      //      isSelectAllChecked: false,
      total: 0,
      basePath: '',
      job: undefined,
      isJobImageFormModalOpen: false,
      //      currentTabIndex: 0,
      isConfirmHideModalOpen: false,
      selectedImageToHide: undefined,
      isConfirmPreferredModalOpen: false,
      selectedImageForPreferred: undefined,
      existingPreferredImage: undefined,
      isPreviewModalOpen: false,
      selectedImageForPreview: undefined,
      previewId: '',
      editingImage: undefined,
      isReadOnlyMode: false,

      isConfirmFinalApproveModalOpen: false,
      selectedImageToApprove: undefined,
    };
  }

  private approveSingleImage = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });
    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isApproved: true })
      .then(() => this.setItems())
      .finally(() => this.setState({ isLoading: false }));
  };

  getJobId(): string {
    const { history, location } = this.props;
    const search = parse(history.location.search);
    const jobId = location.state?.jobId || (search.job as string);
    return jobId;
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.setAdditionalItems().then(res => {
      if (this.state.job) {
        this.setItems();
      }
    });
  }

  setAdditionalItems() {
    const { user } = this.props;
    const jobId = this.getJobId();

    return getSchoolUserSchoolJob(user, jobId)
      .then(job => {
        if (!job) {
          throw new Error('Job not found');
        }

        this.setState({
          job: job,
          isLoading: false,
        });

        return true;
      })
      .catch(error => {
        console.error('Error fetching job:', error);
        this.setState({ isLoading: false });
      });
  }

  getColumns(): ColumnDefinition[] {
    const { job } = this.state;

    if (!job) {
      return [...BASE_COLUMNS];
    }

    const isGroupJob = job.photoType.name === 'Group';
    let columns: ColumnDefinition[];

    if (isGroupJob) {
      columns = [
        { text: 'Image', field: 'image', isSort: false, type: FILTER_TYPE.NONE, cell: imageCell },
        { text: 'Group Name', field: 'groupName', isSort: false, type: FILTER_TYPE.TEXT, accessor: ['groupName'] },
        { text: 'Status', field: 'isApproved', isSort: false, type: FILTER_TYPE.SELECT, accessor: getIsApproved },
      ];
    } else {
      columns = [...BASE_COLUMNS];
    }

    columns.push({
      text: 'Actions',
      field: 'actions',
      isSort: false,
      cell: (item: SchoolImageWithTicket): JSX.Element => {
        const jobStatus = job?.status;
        const isApprovedBySchool = jobStatus === SCHOOL_JOB_STATUS.APPROVED_BY_SCHOOL;
        const canOpenForm = jobStatus === SCHOOL_JOB_STATUS.NEW || isApprovedBySchool;

        return (
          <td className="custom-action-cell">
            <div className="action-button-container">
              <button onClick={() => this.onPreviewImageClick(item)} className="modern-button modern-save-button mr-2">
                Preview
              </button>
              <button
                onClick={() => (isApprovedBySchool ? this.onViewImageClick(item) : this.onEditImageClick(item))}
                className="modern-button modern-edit-button mr-2"
                disabled={!canOpenForm}
              >
                {isApprovedBySchool ? 'View' : 'Edit'}
              </button>
              {!item.isApproved && (
                <button
                  onClick={() => this.onApproveImageClick(item)}
                  className="modern-button modern-save-button mr-2"
                  disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                >
                  Approve
                </button>
              )}
              {item.isApproved && (
                <button
                  onClick={() => this.onCancelApprovalClick(item)}
                  className="modern-button modern-cancel-button mr-2"
                  disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                >
                  Cancel Approval
                </button>
              )}
              {!isGroupJob && (
                <>
                  <button
                    type="button"
                    className="modern-button modern-cancel-button mr-2"
                    disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                    onClick={() => this.onHideImageClick(item)}
                  >
                    Hide
                  </button>
                  {item.isPreferred ? (
                    <button
                      onClick={() => this.onUnstarImageClick(item)}
                      className="custom-action-button-thumbnails star-button"
                      disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                      style={{ marginLeft: '8px' }}
                    >
                      <img src="/dist/images/icon/unstar.png" alt="Unstar" className="star-icon" />
                    </button>
                  ) : (
                    <button
                      onClick={() => this.onPreferredClick(item)}
                      className="custom-action-button-thumbnails star-button"
                      disabled={jobStatus !== SCHOOL_JOB_STATUS.NEW}
                      style={{ marginLeft: '8px' }}
                    >
                      <img src="/dist/images/icon/star.png" alt="Preferred" className="star-icon" />
                    </button>
                  )}
                </>
              )}
            </div>
          </td>
        );
      },
    });
    return columns;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true,
      });
      this.setItems();
    }
  }

  setItems(): Promise<boolean> {
    const { history, user } = this.props;
    const { job } = this.state;
    if (!job) return Promise.resolve(false);

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection = '';
    let sortColumnsName = '';
    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const filters = getFilters(this.getColumns(), search);
    const isShowFilter = isFilterExist(filters);
    const isDataFiltered = isShowFilter;
    const where = getServerFieldSectionWhere(filters);

    const order = sortColumnsName && sortDirection ? `${sortColumnsName} ${sortDirection}` : undefined;

    const serverQueryFilter = getServerQueryFilter(page, where, order);
    const jobId = this.getJobId();

    const countP = getSchoolUserSchoolJobImagesCount(user, jobId, where);
    const itemsP = getSchoolUserSchoolJobImages(user, jobId, serverQueryFilter);

    return Promise.all([countP, itemsP]).then(([countObj, items]) =>
      Promise.all(
        items.map(item => {
          const useKey =
            job.photoType.name === 'Group' && item.isEdited && item.keyForEdit ? item.keyForEdit : item.key;
          const useMime =
            job.photoType.name === 'Group' && item.isEdited && item.mimeTypeForEdit
              ? item.mimeTypeForEdit
              : item.mimeType;
          return createSchoolUserSchoolJobImageTicket(user, { key: useKey, mimeType: useMime });
        })
      ).then(tickets => {
        const imagesExtended = items.map((item, i) => ({
          ...item,
          ticket: tickets[i],
        }));

        this.setState({
          currentPage: page,
          sortDirection: sortDirection as TABLE_SORT_DIRECTION,
          sortColumnsName,
          isShowFilter,
          isDataFiltered,
          filters,
          items: imagesExtended,
          total: countObj.count,
          basePath: history.location.pathname,
          isLoading: false,
        });

        return true;
      })
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  /*  onItemClick = (index: number) => {
    const item = this.state.items[index];
    this.onPreviewImageClick(item);
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const selectedItemsNext = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: selectedItemsNext,
      isSelectAllChecked: true,
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
    });

    const user = this.props.user;

    const where = getServerFieldSectionWhere(filters);

    const jobId = this.getJobId();

    getSchoolUserAllSchoolJobImages(user, jobId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const selectedItemsNext = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: selectedItemsNext,
        isSelectAllChecked: true,
        isLoading: false,
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
    });
  };
*/
  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue,
            },
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue,
            },
          };
          break;
        case CHECKBOX_FIELDS.CHECKBOX: {
          const checked = event.target.checked;
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              value: '',
              checked: checked,
            },
          };
          break;
        }
        case CHECKBOX_FIELDS.TEXT:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              value: filterValue,
            },
          };
          break;
      }
    } else {
      const filter = BASE_COLUMNS.find(col => col.field === filterField);
      const filterType = filter?.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value,
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue,
        };
      }
    }

    this.setState({
      filters: nextFilters,
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist(filters);

    const filtersConverted = convertToFilterWithPlus(filters);

    if (isFilter) {
      search.push(getSearchFilter(filtersConverted));
    }

    this.setState({});

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}&${search.join('&')}`,
      state: history.location.state,
    });
  };

  onClearFilterClick = (): void => {
    this.setState({});

    const jobId = this.getJobId();

    const { history } = this.props;

    this.props.history.push({
      pathname: this.state.basePath,
      search: `job=${jobId}`,
      state: history.location.state,
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter,
    });
  };

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const { search } = state as any;
    const jobId = this.getJobId();

    history.push({
      pathname: '/schoolJobs',
      search: search,
      state: { jobId: jobId },
    });
  };

  onViewImageClick = (item: SchoolImageWithTicket) => {
    if (item.photoType?.name === 'Group') {
      this.props.history.push({
        pathname: `/schoolJobs/${this.getJobId()}/images/group-view/${item.id}`,
        state: { image: item, readOnly: true },
      });
    } else {
      this.setState({
        editingImage: item,
        isJobImageFormModalOpen: true,
        isReadOnlyMode: true,
      });
    }
  };

  onEditImageClick = (item: SchoolJobImage) => {
    if (item.photoType?.name === 'Group') {
      this.props.history.push({
        pathname: `/schoolJobs/${this.getJobId()}/images/group-edit/${item.id}`,
        state: { image: item },
      });
    } else {
      const imageWithTicket: SchoolImageWithTicket = {
        ...item,
        ticket: (item as any).ticket || { ticket: '' },
      };
      this.setState({
        editingImage: imageWithTicket,
        isJobImageFormModalOpen: true,
        isReadOnlyMode: false,
      });
    }
  };

  onHideImageClick = (item: SchoolImageWithTicket) => {
    this.setState({
      isConfirmHideModalOpen: true,
      selectedImageToHide: item,
    });
  };

  onPreferredClick = (item: SchoolImageWithTicket) => {
    if (item.isPreferred) return;

    const existingPreferred = this.state.items.find(
      i =>
        i.staffData?.name === item.staffData?.name &&
        i.staffData?.surname === item.staffData?.surname &&
        i.isPreferred === true
    );

    if (existingPreferred) {
      this.setState({
        isConfirmPreferredModalOpen: true,
        selectedImageForPreferred: item,
        existingPreferredImage: existingPreferred,
      });
    } else {
      const { user } = this.props;
      const jobId = this.getJobId();
      updateSchoolUserSchoolJobImage(user, jobId, item.id, { isPreferred: true })
        .then(() => {
          this.setItems();
        })
        .catch(error => {
          console.error('Error setting preferred image:', error);
        });
    }
  };

  onUnstarImageClick = (item: SchoolImageWithTicket) => {
    const { user } = this.props;
    const jobId = this.getJobId();
    updateSchoolUserSchoolJobImage(user, jobId, item.id, { isPreferred: false })
      .then(() => {
        this.setItems();
      })
      .catch(error => {
        console.error('Error unsetting preferred image:', error);
      });
  };

  onCancelButtonClick = () => {
    this.setState({
      isJobImageFormModalOpen: false,
      editingImage: undefined,
      isReadOnlyMode: false,
    });
  };

  onSubmitForm = (data: any) => {
    const { editingImage } = this.state;
    const { user } = this.props;
    if (!editingImage) return;

    const jobId = this.getJobId();
    const id = editingImage.id;

    this.setState({ isLoading: true });

    updateSchoolUserSchoolJobImage(user, jobId, id, data)
      .then(updatedImage => {
        return createSchoolUserSchoolJobImageTicket(user, updatedImage).then(ticket => ({ ...updatedImage, ticket }));
      })
      .then(imageWithTicket => {
        this.setState(
          {
            isJobImageFormModalOpen: false,
            editingImage: undefined,
          },
          () => this.setItems()
        );
      })
      .catch(err => {
        console.error('Error updating image:', err);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  closeConfirmHideModal = () => {
    this.setState({
      isConfirmHideModalOpen: false,
      selectedImageToHide: undefined,
    });
  };

  confirmHideImage = () => {
    const { user } = this.props;
    const { selectedImageToHide } = this.state;
    if (!selectedImageToHide) return;

    const jobId = this.getJobId();
    const imageId = selectedImageToHide.id;

    updateSchoolUserSchoolJobImage(user, jobId, imageId, { isHidden: true })
      .then(() => {
        this.closeConfirmHideModal();
        this.setItems();
      })
      .catch(error => {
        console.error('Error hiding image:', error);
      });
  };

  closeConfirmPreferredModal = () => {
    this.setState({
      isConfirmPreferredModalOpen: false,
      selectedImageForPreferred: undefined,
      existingPreferredImage: undefined,
    });
  };

  confirmPreferredImage = () => {
    const { user } = this.props;
    const jobId = this.getJobId();
    const { selectedImageForPreferred, existingPreferredImage } = this.state;
    if (!selectedImageForPreferred) return;

    updateSchoolUserSchoolJobImage(user, jobId, selectedImageForPreferred.id, { isPreferred: true })
      .then(() => {
        if (existingPreferredImage) {
          return updateSchoolUserSchoolJobImage(user, jobId, existingPreferredImage.id, { isPreferred: false });
        }
      })
      .then(() => {
        this.closeConfirmPreferredModal();
        this.setItems();
      })
      .catch(error => {
        console.error('Error updating preferred image:', error);
      });
  };

  renderFormModal(): React.ReactNode {
    const { isJobImageFormModalOpen, editingImage, isReadOnlyMode } = this.state;
    if (!isJobImageFormModalOpen || !editingImage) return null;

    return (
      <SimpleModal
        isOpen={isJobImageFormModalOpen}
        customClass="custom-user-modal"
        onCloseClick={this.onCancelButtonClick}
      >
        <SchoolAppSchoolJobImageForm
          image={editingImage}
          onCancel={this.onCancelButtonClick}
          onSubmit={this.onSubmitForm}
          readOnly={isReadOnlyMode}
        />
      </SimpleModal>
    );
  }

  onPreviewImageClick = (item: SchoolImageWithTicket) => {
    const { user } = this.props;
    if (item.photoType?.name === 'Group' && item.isEdited) {
      const params = {
        imageId: item.id,
        job: item.job,
        fileName: item.fileName,
        mimeType: item.mimeType,
        key: item.key,
        groupName: item.groupName,
        school: item.school,
        photoType: item.photoType,
        fontName: item.fontName,
        groupStudents: item.groupStudents,
        crestLeft: item.crestLeft?.pic || '',
        crestRight: item.crestRight?.pic || '',
      };
      createSchoolUserImagePreview(user, params)
        .then(data =>
          this.setState({ selectedImageForPreview: item, previewId: data.previewId, isPreviewModalOpen: true })
        )
        .catch(err => console.error('Error generating preview', err));
    } else {
      this.setState({ selectedImageForPreview: item, previewId: '', isPreviewModalOpen: true });
    }
  };

  onApproveImageClick = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    getSchoolUserAllSchoolJobImages(this.props.user, jobId, {})
      .then(allImages => {
        const stillUnapproved = allImages.filter(img => !img.isApproved && img.id !== item.id);
        if (stillUnapproved.length > 0) {
          this.approveSingleImage(item);
        } else {
          this.setState({
            isConfirmFinalApproveModalOpen: true,
            selectedImageToApprove: item,
          });
        }
      })
      .catch(err => {
        console.error('Error fetching all images for final‐approve check', err);
      });
  };

  onCancelApprovalClick = (item: SchoolImageWithTicket) => {
    const jobId = this.getJobId();
    this.setState({ isLoading: true });
    updateSchoolUserSchoolJobImage(this.props.user, jobId, item.id, { isApproved: false })
      .then(() => this.setItems())
      .finally(() => this.setState({ isLoading: false }));
  };

  closeConfirmFinalApproveModal = () => {
    this.setState({
      isConfirmFinalApproveModalOpen: false,
      selectedImageToApprove: undefined,
    });
  };

  confirmFinalApprove = () => {
    const { selectedImageToApprove } = this.state;
    const jobId = this.getJobId();
    if (!selectedImageToApprove) return;

    this.setState({ isLoading: true });

    updateSchoolUserSchoolJobImage(this.props.user, jobId, selectedImageToApprove.id, { isApproved: true })
      .then(() => approveSchoolJob(this.props.user, jobId))
      .then(() => getSchoolUserSchoolJob(this.props.user, jobId))
      .then(freshJob => {
        this.setState({ job: freshJob });
      })
      .then(() => this.setItems())
      .catch(err => console.error('Error during final approve', err))
      .finally(() => {
        this.setState({
          isLoading: false,
          isConfirmFinalApproveModalOpen: false,
          selectedImageToApprove: undefined,
        });
      });
  };

  closePreviewModal = () => {
    this.setState({
      isPreviewModalOpen: false,
      selectedImageForPreview: undefined,
      previewId: '',
    });
  };

  renderPreviewModal(): React.ReactNode {
    const { isPreviewModalOpen, selectedImageForPreview, previewId } = this.state;
    if (!isPreviewModalOpen || !selectedImageForPreview) return null;

    const mainUrl = `${window.apiFile}/storage/images/${selectedImageForPreview.ticket.ticket}`;
    const previewUrl = previewId ? `${window.apiBase}/schoolUser/imagePreview/${previewId}?t=${Date.now()}` : undefined;

    const isGroupJob = selectedImageForPreview.photoType?.name === 'Group';

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        this.closePreviewModal();
      }
    };

    return (
      <div
        className="custom-modal-backdrop"
        onClick={handleBackdropClick}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          className="custom-modal-container"
          onClick={e => e.stopPropagation()}
          style={{
            position: 'relative',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '8px',
            width: '80%',
            maxWidth: '800px',
            maxHeight: '90vh',
            overflowY: 'auto',
          }}
        >
          <button
            onClick={this.closePreviewModal}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              fontSize: '24px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              lineHeight: 1,
            }}
            aria-label="Close"
          >
            &times;
          </button>

          {isGroupJob && (
            <p
              style={{
                fontStyle: 'italic',
                marginBottom: '10px',
                color: '#FF4500',
                textAlign: 'center',
                fontSize: '1.25em',
              }}
            >
              This content is for preview only. The final printed result may differ.
            </p>
          )}

          <SchoolAppSchoolJobImageSummary
            mainUrl={mainUrl}
            previewUrl={previewUrl}
            isEdited={!!selectedImageForPreview.isEdited}
          />
        </div>
      </div>
    );
  }

  renderConfirmFinalApproveModal(): React.ReactNode {
    if (!this.state.isConfirmFinalApproveModalOpen) return null;
    return (
      <SimpleModal isOpen={true} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Approve Last Image?</h2>
          <p>
            Once you approve this image, <strong>all</strong> images in this job will be approved and the entire job
            will automatically move to the “Approved by School” status. If you need to do any further checks, please
            cancel and review before proceeding.
          </p>
          <div className="d-flex justify-content-end" style={{ gap: '8px', marginTop: '20px' }}>
            <Button
              onClick={this.confirmFinalApprove}
              text="Yes, approve and finish job"
              customClass="modern-button modern-save-button"
            />
            <Button
              onClick={this.closeConfirmFinalApproveModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderGrid(): React.ReactNode {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      //      selectedItems,
      filters,
      //      isSelectAllChecked,
      currentPage,
      total,
      job,
    } = this.state;

    if (!job) {
      return <Loader />;
    }

    const filterOptions = {
      isApproved: getSelectOptionForSchoolImageStatus(),
    };

    const gridTitle = `Job ${job.jobReference} / Images`;

    return (
      <Grid
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={false}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={[]}
        columns={this.getColumns()}
        actionItems={[]}
        options={filterOptions}
        onItemClick={() => {}}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={() => {}}
        onSelectAllOnPageClick={() => {}}
        onUnselectAllClick={() => {}}
        gridTitle={gridTitle}
        goBack={this.goBack}
        rowClassName="custom-table-row"
        disableCsvButton={true}
        filterButtonsVariant="schoolApp"
        disableSelection={true}
      />
    );
  }

  /*  getTabs(): React.ReactNode {
    const { currentTabIndex, selectedItems, previewId } = this.state;

    const tabs = SCHOOL_JOB_IMAGES_TABS;
    const currentTab = tabs[currentTabIndex];
    const [image] = selectedItems;

    const previewUrl = previewId ? `${window.apiBase}/schoolUser/imagePreview/${previewId}?t=${Date.now()}` : undefined;

    switch (currentTab) {
      case TABS.SUMMARY:
        const mainUrl = `${window.apiFile}/storage/images/${image.ticket.ticket}`;
        const previewUrl = this.state.previewId
          ? `${window.apiBase}/schoolUser/imagePreview/${this.state.previewId}?t=${Date.now()}`
          : undefined;

        return <SchoolAppSchoolJobImageSummary mainUrl={mainUrl} previewUrl={previewUrl} isEdited={!!image.isEdited} />;
      default:
        return <div />;
    }
  }

  onTabClick = (event, index: number) => {
    event.preventDefault();

    this.setState({
      currentTabIndex: index,
    });
  };

  renderSummary(): React.ReactNode {
    const { selectedItems, currentTabIndex } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select an image above</div>;
    }

    const tabs = this.getTabs();

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={SCHOOL_JOB_IMAGES_TABS} currentTabIndex={currentTabIndex}>
        {tabs}
      </GenericSummary>
    );
  }
*/
  renderConfirmHideModal(): React.ReactNode {
    if (!this.state.isConfirmHideModalOpen) return null;
    return (
      <SimpleModal isOpen={this.state.isConfirmHideModalOpen} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Confirm Hide</h2>
          <p>
            Are you sure you want to hide this image? Once hidden, it will be removed and won't be available anymore.
          </p>
          <div className="custom-button-container d-flex justify-content-end" style={{ gap: '8px' }}>
            <Button onClick={this.confirmHideImage} text="Confirm" customClass="modern-button modern-save-button" />
            <Button
              onClick={this.closeConfirmHideModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  renderConfirmPreferredModal(): React.ReactNode {
    if (!this.state.isConfirmPreferredModalOpen) return null;
    return (
      <SimpleModal isOpen={this.state.isConfirmPreferredModalOpen} customClass="custom-user-modal">
        <div style={{ padding: '20px' }}>
          <h2>Replace Preferred Image?</h2>
          <p>
            There is already an image for this member of staff marked as preferred. Would you like to replace the
            preferred image?
          </p>
          <div className="custom-button-container d-flex justify-content-end" style={{ gap: '8px', marginTop: '20px' }}>
            <Button
              onClick={this.confirmPreferredImage}
              text="Confirm"
              customClass="modern-button modern-save-button"
            />
            <Button
              onClick={this.closeConfirmPreferredModal}
              text="Cancel"
              customClass="modern-button modern-cancel-button"
            />
          </div>
        </div>
      </SimpleModal>
    );
  }

  render() {
    const { isLoading, isJobImageFormModalOpen, job } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    if (!job) {
      return <div>No job found. Please go back and select a job.</div>;
    }

    const classes = isJobImageFormModalOpen ? 'mt-3 modal-open' : 'mt-3';

    return (
      <div className={`${classes} schoolAppContentWrapper2`}>
        {' '}
        {this.renderFormModal()}
        {this.renderConfirmHideModal()}
        {this.renderConfirmPreferredModal()}
        {this.renderConfirmFinalApproveModal()}
        {this.renderPreviewModal()}
        <div className="row">
          <div className="col-md-12">
            <div className="resizable-panel">{this.renderGrid()}</div>
          </div>
        </div>
      </div>
    );
  }
}
